import { ChangeEvent, FC, ReactNode, useRef } from 'react'
import { SideoverState } from '@/states'
import { PicImageUpload, VideoUpload } from '@/helpers'
import { useNotification } from '@/hooks'
import { ALLOWED_IMAGE_TYPES, ALLOWED_VIDEO_TYPES } from '@/data'

const Upload: FC<UploadComponentProps> = (props): ReactNode => {
    const { target, icon } = props

    const { Form, Loading, SetState } = SideoverState()
    const { InitNotification } = useNotification()

    const InputRef = useRef<HTMLInputElement>(null)

    const HandleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (!Loading) {
            SetState({ Loading: true })

            if (target === 'Image') PicImageUpload({
                e,
                fileInputRef: InputRef,
                Form,
                SetState,
                Notification: InitNotification
            })

            if (target === 'Video') VideoUpload({
                e,
                fileInputRef: InputRef,
                Form,
                SetState,
                Notification: InitNotification
            })
        }
    }

    if (!Form[target]) return (
        <div className={`flex flex-col items-center justify-center w-full h-48 border-2 border-[#424242] border-dashed rounded-md bg-[#4A4A4A] relative ${Loading ? 'cursor-default' : 'cursor-pointer'}`}>
            <div className='flex flex-col items-center justify-center pt-5 pb-6'>
                {icon}

                <p className='text-sm text-[#EBEBEB] mt-3'>
                    <span className='font-semibold'>Click</span> or <span className='font-semibold'>Drag</span> to upload {target}.
                </p>

                <p className='text-xs text-[#9a9d9e] w-[75%] text-center'>
                    Allowed formats are: {target === 'Image' ? ALLOWED_IMAGE_TYPES.replace('image/', '.') : ALLOWED_VIDEO_TYPES.replace('video/', '.')}.
                </p>
            </div>

            <input
                type='file'
                className={`absolute cursor-pointer w-full h-full opacity-0 top-0 right-0 left-0 bottom-0 z-[9999] ${Loading ? 'cursor-default' : 'cursor-pointer'}`}
                title=''
                disabled={Loading}
                onClick={(e) => Loading ? () => {} : e.currentTarget.value = ''}
                accept={target === 'Image' ? ALLOWED_IMAGE_TYPES : ALLOWED_VIDEO_TYPES}
                onChange={(e) => HandleFileChange(e)}
            />
        </div>
    )
}

export default Upload
